/* eslint-disable */
if (!customElements.get('decking-calculator')) {
  const STORAGE_KEY = 'decking-calculator-dimensions';

  customElements.define('decking-calculator', class DeckingCalculator extends HTMLElement {
    static get MULTIPLIERS() {
      return { '3.6m': 2, '4.8m': 1.4 };
    }

    constructor() {
      super();
      this._currentVariant = null;
      this._boundHandleInput = this._handleInput.bind(this);
      this._boundVariantChange = this._onVariantChange.bind(this);
      this._boundVariantUpdated = this._onVariantUpdated.bind(this);
      this._boundCartAdded = this._onCartAdded.bind(this);
    }

    connectedCallback() {
      this._variants = this._parseVariants();
      this._sectionId = this.getAttribute('data-section-id') || '';
      this._cacheElements();
      this._restoreDimensions();
      this._attachListeners();
      if (window.eventBus) {
        window.eventBus.on('variant:change', this._boundVariantChange);
        window.eventBus.on('variant:updated', this._boundVariantUpdated);
        window.eventBus.on('cart:added', this._boundCartAdded);
      }
      this._runUpdate();
    }

    disconnectedCallback() {
      this._detachListeners();
      if (window.eventBus) {
        window.eventBus.off('variant:change', this._boundVariantChange);
        window.eventBus.off('variant:updated', this._boundVariantUpdated);
        window.eventBus.off('cart:added', this._boundCartAdded);
      }
    }

    _parseVariants() {
      const script = this.querySelector('script[data-decking-calculator-variants]');
      if (script && script.textContent) {
        try {
          return JSON.parse(script.textContent.trim());
        } catch (e) {
          return [];
        }
      }
      try {
        const raw = this.getAttribute('data-variants');
        if (!raw) return [];
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch (e) {
        return [];
      }
    }

    _cacheElements() {
      this._widthInput = this.querySelector('#width-input') || this.querySelector('[name="width"]');
      this._lengthInput = this.querySelector('#length-input') || this.querySelector('[name="length"]');
      this._areaEl = this.querySelector('#area-input');
      this._priceEl = this.querySelector('#calculators-price');
    }

    _getQuantityInput() {
      const form = this.closest('form');
      if (form) {
        const q = form.querySelector('#Quantity');
        if (q) return q;
      }
      return document.getElementById('Quantity');
    }

    _getMultiplier(variant) {
      const multipliers = this.constructor.MULTIPLIERS;
      if (variant) {
        for (const opt of [variant.option1, variant.option2, variant.option3]) {
          if (opt == null || opt === '') continue;
          let key = String(opt).trim().toLowerCase()
            .replace(/\s+/g, '')
            .replace(/\s*board[s]?$/i, '');
          if (multipliers[key] != null) return multipliers[key];
          if (key.includes('3.6')) return 2;
          if (key.includes('4.8') || key.includes('4.6')) return 1.4;
        }
      }
      const title = (this.getAttribute('data-product-title') || '').toLowerCase();
      if (title.includes('3.6')) return 2;
      if (title.includes('4.8') || title.includes('4.6')) return 1.4;
      return 1.4;
    }

    _getCurrentVariant() {
      if (this._currentVariant) return this._currentVariant;
      const form = this.closest('form');
      const idInput = form?.querySelector('input[name="id"]');
      const id = idInput?.value || new URLSearchParams(window.location.search).get('variant');
      if (id && this._variants.length) {
        const v = this._variants.find(vr => String(vr.id) === String(id));
        if (v) return v;
      }
      return this._variants[0] || null;
    }

    _setCurrentVariant(variant) {
      this._currentVariant = variant || null;
    }

    _restoreDimensions() {
      if (!this._widthInput || !this._lengthInput) return;
      try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
          const { width, length } = JSON.parse(stored);
          if (typeof width === 'number' && width > 0) this._widthInput.value = width;
          if (typeof length === 'number' && length > 0) this._lengthInput.value = length;
        }
      } catch (_) {}
    }

    _persistDimensions() {
      if (!this._widthInput || !this._lengthInput) return;
      try {
        const w = parseFloat(this._widthInput.value);
        const l = parseFloat(this._lengthInput.value);
        if (!Number.isNaN(w) && !Number.isNaN(l) && w > 0 && l > 0) {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ width: w, length: l }));
        }
      } catch (_) {}
    }

    _handleInput() {
      this._persistDimensions();
      this._runUpdate();
    }

    _onVariantChange(evt) {
      if (evt && evt.variant) this._setCurrentVariant(evt.variant);
    }

    _onVariantUpdated(evt) {
      if (evt && evt.variant) this._setCurrentVariant(evt.variant);
      setTimeout(() => this._runUpdate(), 0);
    }

    _onCartAdded(data) {
      if (data && data.sectionId === this._sectionId) {
        this._persistDimensions();
        setTimeout(() => this._runUpdate(), 100);
      }
    }

    _attachListeners() {
      if (this._widthInput) {
        this._widthInput.addEventListener('input', this._boundHandleInput);
        this._widthInput.addEventListener('change', this._boundHandleInput);
      }
      if (this._lengthInput) {
        this._lengthInput.addEventListener('input', this._boundHandleInput);
        this._lengthInput.addEventListener('change', this._boundHandleInput);
      }
    }

    _detachListeners() {
      if (this._widthInput) {
        this._widthInput.removeEventListener('input', this._boundHandleInput);
        this._widthInput.removeEventListener('change', this._boundHandleInput);
      }
      if (this._lengthInput) {
        this._lengthInput.removeEventListener('input', this._boundHandleInput);
        this._lengthInput.removeEventListener('change', this._boundHandleInput);
      }
    }

    _runUpdate() {
      const w = parseFloat(this._widthInput?.value) || 0;
      const l = parseFloat(this._lengthInput?.value) || 0;
      const area = Math.max(0, w * l);
      const areaStr = area.toFixed(2);

      if (this._areaEl) this._areaEl.textContent = areaStr;

      const variant = this._getCurrentVariant();
      const multiplier = this._getMultiplier(variant);
      const boards = Math.max(1, Math.ceil(area * multiplier));

      const qtyInput = this._getQuantityInput();
      if (qtyInput) {
        qtyInput.value = boards;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      const hiddenQty = this.closest('form')?.querySelector('input[name="quantity"]');
      if (hiddenQty) hiddenQty.value = boards;

      if (window.eventBus && this._sectionId) {
        window.eventBus.emit('qty:change', { value: boards, sectionId: this._sectionId });
      }

      const pricePence = variant ? (Number(variant.price) || 0) : 0;
      const totalPounds = ((pricePence * boards) / 100).toFixed(2);
      if (this._priceEl) this._priceEl.textContent = '£' + totalPounds;
    }
  });
}
